var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailwizz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSerif: "http://www.serif.com/",
    viewBox: "0 0 308 81",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-442,-358)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06902,0,0,1.00794,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Color-Light-BG",
    serifId: "Logo Color Light BG",
    transform: "matrix(0.844736,0,0,0.844736,134.624,18.3947)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.195,1.26775e-47,-5.97656e-48,4.44925,-1790.91,-1290.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Color-Black",
    serifId: "Text Color Black"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.9299,0,0,15.9299,527.353,395.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.76.0V-.667H.54L.408-.228.276-.667H.057V0H.213L.208-.501.352.0H.465L.609-.501.603.0H.76z",
    style: {
      fill: "#252525",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.9299,0,0,15.9299,540.049,395.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.577.0V-.5H.437v.053C.405-.504.346-.518.284-.518c-.156.0-.256.115-.256.269.0.153.096.266.253.266.06.0.127-.013.156-.07V0h.14zM.428-.251c0 .074-.051.129-.125.129-.072.0-.126-.056-.126-.127S.23-.377.301-.377c.073.0.127.054.127.126z",
    style: {
      fill: "#252525",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.9299,0,0,15.9299,549.719,395.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.2-.553V-.667H.051v.114H.2zM.2.0V-.5H.051V0H.2z",
    style: {
      fill: "#252525",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.9299,0,0,15.9299,553.382,395.846)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.051,
    y: -0.667,
    width: 0.149,
    height: 0.667,
    style: {
      fill: "#252525",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.9299,0,0,15.9299,557.046,395.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.861-.667H.688L.597-.231.499-.667H.368L.269-.233.18-.667H.007L.179.0H.332L.433-.431.534.0h.15L.861-.667z",
    style: {
      fill: "#2250fc",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.9299,0,0,15.9299,570.491,395.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.2-.553V-.667H.051v.114H.2zM.2.0V-.5H.051V0H.2z",
    style: {
      fill: "#2250fc",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.9299,0,0,15.9299,574.155,395.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.389.0V-.113H.193L.389-.386V-.5H.017v.113h.21l-.21.284V0H.389z",
    style: {
      fill: "#2250fc",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.9299,0,0,15.9299,580.607,395.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.389.0V-.113H.193L.389-.386V-.5H.017v.113h.21l-.21.284V0H.389z",
    style: {
      fill: "#2250fc",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Symbol-Blue",
    serifId: "Symbol Blue",
    transform: "matrix(1,0,0,1,-19.7895,14.3717)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.34555,0,0,1.38188,-543.571,-564.391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721.648 704.343 692.963 721.341 664.278 704.343V738.339L692.963 755.337 721.648 738.339V704.343z",
    style: {
      fill: "#2250fc"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.34555,0,0,1.38188,-543.571,-564.391)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.822987,-0,-0,0.849916,664.004,686.535)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 0.334,
    y: 40.952,
    width: 34.855,
    height: 40,
    transform: "matrix(0.995853,0,0,1,0,0)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-4.35329,-5.25434e-16,3.94924e-16,-3.17827,2059.83,2242.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.71 576.924 383.844 584.314 374.977 576.924H392.71z",
    style: {
      fill: "#2250fc"
    }
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: 35,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAoCAYAAAB0HkOaAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAD8UlEQVRYhcWWbWscVRiGrzP2b/hF/EH+IIuoVUQECUa0NhVEm1pREEQaEfzgGxXBBqr40mgTTNPUuEn2LTs7c865/TBzZs5sZrdds0keWHbm4bxc536e++yap56xnHe4rKv03x+4cJ4Q8pnS/XXGvd/Au/OCkbLeXdKDO8iNMAIZc/YwdvRQ6cE6PusieSABA0hnB+PzgcaHP2NHDwoIYzAYhAEVz6cOI58r690lH2wiOTBJEAJQAWQMkJwmjJQPt8n7f+LdGIyBUgUwGFOqEuVOBcaN95X1N/B2AGVJQimEqd4hAcCgxTew3EhZ/x5uvA94KE8el6IokZo9Q7K4Bpas7NEOdrQLcpESCTIqgBSVxSRl04T3YuwJYSSXdrCjHbzPq8Wb/VCUAlNvXoAVljYInbRnfD6QTXfx9gjkG6WgdEqjRJM9Q9w3RdnmhpHP5NJ/cHkfpMYGcSmOucUksaDNeSRIzAEjL5cd4LLDoi8wpfTNe6M+db25QTUkdYlADas/Doy8HRQQ3payR64otwsQRgli0i1BnfKZlrLpETDymXzWQ348cWoTbRa7JQHqe6V2y8Sta2pLV3kzzdpy8naI3Bjhi8VEvXF8P0ANQKSOiUqkqESTzTxdGUkuw7t06gmjoa0/ds0bdj6rBxghh/cZyBWTFWRUadkWt8SgFaxqsIbVyxJV6pRrk1RgF0CS94BrSNe4wkOJGg1Yn7BWh8KmoYFnWj2U2VfwydWLT/D0k0SnK09o2k5dTKqu8GrB8tlQ5pMqX6wX1klKtaMShrxJMJKwDn1w07F0PaPb9+U/MA9yxXP5EeW3XJU7nleUK94lV67nq/XiXMib+q6Aw770+rWM1bUc6+LJxcQazFUA1Zg2oAasaxnbXLsBE2Ljb68XVlK++Sk/psQxiAnQCrgBH8+bVLteuxUmxFc/Wl1aOeLetm0tURPseCliJeIcuFb4mTAA1qH3PhuzdH1Ir+/aS9S2AT4ql5uuapR/JEyIg5702vtDPrx5hHN1H7SpUOc1XTUiyMdVZjL+2HJ6/nKPb2+nj9WUzWaepmoBNjdMiC9vjXXpSpfN+9kMq89qZtcYcyIYKPrp6qcD3rh2SG9oSxXc/7b6iWBC7Pe8Xn33kBtrPZyb1+p17ywEJsTvm7mee7PD9+vDlqZtU63pxIXChFj77kgvXdljczudy+qnAgNgnfTOx12WV/foD/LZVl9kz8yKTtfplZU9Plrr4Nyk1ef4OVhk/PrXWBeXd7l1u8c0q58ZTIjPv+7r5cs7bN0fTVj9DJWJw1rprRsdlld3GAzyCuhcYEJ0Dq1efPsBn3zxEO/OGSbELxupnl3a4j+9CKa4yFZIZQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailwizz);
export default __webpack_public_path__ + "static/media/mailwizz.5bd803d1237fe71d5a2a39720e123939.svg";
export { ForwardRef as ReactComponent };